import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';

export const trackToggleShowBalance = (from: string, option: boolean) => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_hide_or_show_balance, {
    from,
    option: option ? 'show' : 'hide',
  });
};
